import { takeLatest, put, call } from "redux-saga/effects";
import axiosInstance, { axiosSagaRequest } from "clients/api";
import { implementPromiseAction } from "@adobe/redux-saga-promise";
import { appInternalSearchPromise, APP_INTERNAL_SEARCH_CALL } from "./sagas-actions";
import {
  onSuccessInternalSearch,
  onFailedInternalSearch,
  onCallAppInternalSearch,
  onCallAppInternalSearchPromise,
  onSuccessAppInternalSearchPromise
} from "./slice";
import { buildInternalSearchUrl, PAGE_SIZE } from "./categories";

export function* appInternalSearchCallGenerator(action) {
  const {
    payload: { search_value, limit = PAGE_SIZE, offset = 0, category, append } = {}
  } = action;
  yield put(onCallAppInternalSearch({ category, append }));
  try {
    const { data } = yield call(
      axiosSagaRequest,
      "get",
      buildInternalSearchUrl({ search_value, limit, offset, category })
    );
    yield put(onSuccessInternalSearch({ data, category, append }));
  } catch (error) {
    yield put(onFailedInternalSearch());
  }
}

function* appInternalSearchCallPromiseGenerator(action) {
  yield call(implementPromiseAction, action, function* appInternalSearchWorker() {
    yield put(onCallAppInternalSearchPromise());
    try {
      const {
        payload: { search_value, skip, limit, category }
      } = action;
      const { data } = yield call(
        axiosInstance.get,
        buildInternalSearchUrl({ search_value, limit, offset: skip, category })
      );
      return yield put(onSuccessAppInternalSearchPromise(data));
    } catch (error) {
      return Promise.reject(error);
    }
  });
}

export default function* appUniversalSearchSaga() {
  yield takeLatest(APP_INTERNAL_SEARCH_CALL, appInternalSearchCallGenerator);
  yield takeLatest(appInternalSearchPromise, appInternalSearchCallPromiseGenerator);
}
